import GetAppIcon from '@mui/icons-material/GetApp';
import { Menu, MenuItem, Button } from "@mui/material";
import { AgGridReact } from "@ag-grid-community/react";
import { RefObject, useState, useRef } from "react";

const DownloadButton = ({ gridRef }: { gridRef: RefObject<AgGridReact> }) => {
    const [open, setOpen] = useState<boolean>(false);
    const buttonEl = useRef(null);
    const menuStyle = { fontSize: '14px', py: 1 };

    return (
        <>
            <Button
                ref={buttonEl}
                variant='contained'
                color='info'
                size='small'
                startIcon={<GetAppIcon />}
                sx={{ px: 4, lineHeight: '1.5' }}
                id='gridDownload'
                type='button'
                onClick={() => setOpen(true)}
            >
                Download
            </Button>
            <Menu
                id="gridDownload-menu"
                anchorEl={buttonEl.current}
                open={open}
                onClose={() => setOpen(false)}
            >
                <MenuItem
                    sx={menuStyle}
                    onClick={() => {
                        setOpen(false);
                        gridRef.current!.api!.exportDataAsCsv();
                    }}
                >All Rows (CSV)</MenuItem>
                <MenuItem
                    sx={menuStyle}
                    onClick={() => {
                        setOpen(false);
                        gridRef.current!.api!.exportDataAsExcel();
                    }}
                >All Rows (XLS)</MenuItem>
                <MenuItem
                    sx={menuStyle}
                    onClick={() => {
                        setOpen(false);
                        gridRef.current!.api!.exportDataAsCsv({
                            onlySelected: true,
                        });
                    }}
                >Selected Rows (CSV)</MenuItem>
                <MenuItem
                    sx={menuStyle}
                    onClick={() => {
                        setOpen(false);
                        gridRef.current!.api!.exportDataAsExcel({
                            onlySelected: true,
                        });
                    }}
                >Selected Rows (XLS)</MenuItem>
            </Menu>
        </>
    );
}

export default DownloadButton;